module.exports = require("core-js-pure/stable/object/define-properties");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js-stable/object/define-properties.js
// module id = 604
// module chunks = 0